export interface NextStepCard {
  id: number;
  timeframe: string;
  scope: string;
  goal: string;
  action: string;
}

export const cardsData: NextStepCard[] = [
  {
    id: 1,
    timeframe: "1-2 weeks",
    scope: "INITIAL SCOPE",
    goal: "Align on objectives, challenges, and problem scope",
    action:
      "Orientation call, sample use cases, data/policy questionnaire, and high-level value statement",
  },
  {
    id: 2,
    timeframe: "2-8 weeks",
    scope: "PROOF OF CONCEPT (POC)",
    goal: "Prove value and validate assumptions on a use case",
    action:
      "Previously agreed upon POC alongside technical documentation of early results with insights and learnings",
  },
  {
    id: 3,
    timeframe: "2-3 weeks",
    scope: "REQUIREMENT DEFINITION",
    goal: "Convert POC insights into production requirements",
    action:
      "Detailed requirement matrix, model options, governance and compliance design, and implementations roadmap",
  },
  {
    id: 4,
    timeframe: "2-6 months",
    scope: "SCALE-UP (MVP)",
    goal: "Deploy the MVP, integrate systems, optimize workflows",
    action:
      "System configuration, integration with live sources, user onboarding, dashboards; governance and support framework initiation",
  },
  {
    id: 5,
    timeframe: "+1 year",
    scope: "LONG-TERM CONTRACT",
    goal: "Transition from MVP to steady-state operations and continuous value delivery",
    action:
      "Production-grade platform, maintenance and support, roadmap, and quarterly governance cadence",
  },
];

